import { getStore } from '../store/appModuleStore';
import { Module } from 'mini-common-schema';

export const getCurrentModule = (): Module => getStore().module;
